<template>
  <div :class="rootClass" :style="rootStyle" :id="rendering?.dataSource">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <div
        class="button-group-list"
        :style="{
          justifyContent: fields?.layout?.fields?.phrase?.value
            ? fields.layout.fields.phrase.value
            : 'center',
        }"
        v-if="fields?.list?.length > 0"
      >
        <div class="button-group-item" v-for="item in fields?.list" :key="item.id">
          <div
            class="button-group-media-wrapper"
            v-if="item?.fields?.openModal?.value && (fields?.media || fields?.link?.value?.href)"
          >
            <AdaptiveMedia
              v-if="fields?.media"
              class="button-group-media"
              :showImageRedius="false"
              :field="fields?.media"
            />
            <div class="button-group-media-mask" v-if="fields?.media && !isSubmitted"></div>
            <siteButton
              v-bind="item?.fields?.button"
              class="button-group-button"
              :class="{ 'is-overlay': fields?.media }"
              @click="(event) => onButtonClick(event, fields?.link?.value?.href)"
              v-if="(fields?.media && !isSubmitted) || fields?.link?.value?.href"
            />
          </div>
          <siteButton v-bind="item?.fields?.button" v-else-if="!item?.fields?.openModal?.value" />
        </div>
      </div>
    </ContentGrid>
  </div>
</template>

<script>
import { computed, inject, onMounted, ref } from 'vue';
import utils from '@/utils';
import BUS_EVENTS from '@/utils/bus-events';

export default {
  name: 'ButtonGroup',
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
    page: {
      type: Object,
    },
  },
  setup(props) {
    const bus = inject('$bus');
    const isSubmitted = ref(false);

    const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'button-group'));

    const rootStyle = computed(() => {
      const result = utils.overall.baseComStyle(props.fields);
      return result;
    });

    const onButtonClick = (event, href) => {
      event.preventDefault();
      if (href && isSubmitted.value) {
        window.open(href, '_blank');
        return;
      }
      bus?.emit(BUS_EVENTS.FORM_OPEN, {
        onSuccess: () => {
          // 提交成功后在当前页面 URL 拼接 src=success#showPlay
          const url = new URL(window.location.href);
          url.searchParams.set('src', 'success');
          url.hash = 'showPlay';
          window.history.replaceState({}, '', url.toString());
          isSubmitted.value = true;
        },
      });
    };

    onMounted(() => {
      // 读取 URL 参数 src=success，存在则视频正常展示
      const params = new URLSearchParams(window.location.search);
      isSubmitted.value = params.get('src') === 'success';
    });

    return {
      rootClass,
      rootStyle,
      onButtonClick,
      isSubmitted,
    };
  },
};
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';

.button-group {
  position: relative;
  width: 100%;
  padding: 40px 0;

  &-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }

  &-media {
    &-wrapper {
      position: relative;
      width: fit-content;
      max-width: 100%;
    }

    &-mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      backdrop-filter: blur(4px);
      -webkit-backdrop-filter: blur(4px);
      background: rgba(0, 0, 0, 0.2);
      z-index: 1;
    }
  }

  &-button {
    &.is-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;
    }
  }

  @include tablet-landscape {
    padding: 60px 0;

    &-list {
      flex-direction: row;
      align-items: stretch;
    }
  }
}
</style>
